import React from 'react'

const ReferEarn = () => {
  return (
    <div>ReferEarn</div>
  )
}

export default ReferEarn